import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Save, RotateCcw, FileDown } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { downloadPdf } from "./RgpdExportButton";

export const RgpdRegistrySettings = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { http.get("/settings/rgpd-registry").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const save = async () => {
    setBusy("save");
    try { setD((await http.put("/settings/rgpd-registry", { text: d.text })).data); toast.success("Registre enregistré"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  const pdf = async () => {
    setBusy("pdf");
    try { await downloadPdf("/settings/rgpd-registry.pdf", "Registre_RGPD.pdf"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  return (
    <div data-testid="rgpd-registry-settings" className="border border-slate-200 bg-white rounded-md p-6 space-y-4">
      <div className="flex items-center gap-2"><BookOpen className="h-5 w-5 text-slate-700" /><h3 className="font-display text-lg font-extrabold">Registre des traitements (RGPD art. 30)</h3>
        <button type="button" data-testid="rgpd-registry-pdf" onClick={pdf} disabled={busy === "pdf"} className="ml-auto inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-md border border-sky-300 text-sky-800 hover:bg-sky-50 disabled:opacity-60"><FileDown className="h-4 w-4" />{busy === "pdf" ? "Génération…" : "Télécharger le PDF"}</button></div>
      <p className="text-xs text-slate-500 -mt-2">Candidatures, demandes de devis, gestion des agents et contrôles CNAPS. À présenter en cas de contrôle de la CNIL. « ## » = titre, « - Libellé : valeur » = ligne. Enregistrez avant de télécharger. {d.is_default && "Texte standard généré à partir de Paramètres."}</p>
      <textarea data-testid="rgpd-registry-text" rows={14} value={d.text} onChange={(e) => setD({ ...d, text: e.target.value })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm font-mono" />
      <div className="flex items-center gap-3">
        <button type="button" data-testid="rgpd-registry-reset" onClick={() => setD({ ...d, text: d.default_text })} className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-md border border-slate-300 hover:bg-slate-50"><RotateCcw className="h-4 w-4" />Texte standard</button>
        <button type="button" data-testid="rgpd-registry-save" onClick={save} disabled={busy === "save"} className="ml-auto inline-flex items-center gap-1.5 bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-semibold disabled:opacity-60"><Save className="h-4 w-4" />Enregistrer</button>
      </div>
    </div>
  );
};
